import * as React from 'react';
import { useEffect, useState } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import { useSearchParams } from 'react-router-dom';

import { PublicFooter } from '@/components/Footer';
import { PublicHeader } from '@/components/Header';
import { getMeInfo } from '@/features/me';
import { useGeoLocation } from '@/hooks/useGeoLocation';
import { useMe } from '@/hooks/useMe';
import { useUserProducts } from '@/hooks/useUserProducts';
import { getGeoClientData } from '@/lib/AbstractAPI/api/getGeoLocation';
import { GeoClientData } from '@/lib/AbstractAPI/types';
import { getAllAxiosData, GetterAxios } from '@/lib/axios';
import storage from '@/utils/storage';

type PublicLayoutProps = {
  children: React.ReactNode;
  className?: string;
};

export const PublicLayout = (props: any) => {
  const { children, className }: PublicLayoutProps = props;
  const handleError = useErrorHandler();
  const { setMe } = useMe();
  const { setGeoLocation, getGeoLocationCurrencyCode } = useGeoLocation();
  const { setSelectedProductCurrency } = useUserProducts();
  const [searchParams] = useSearchParams();
  const [isOriginSetted, setIsOriginSetted] = useState(false);

  useEffect(() => {
    storage.setExternalOrigin(searchParams.get('origin'));
    setIsOriginSetted(true);

    const setGeolocationData = (geoLocation: GeoClientData) => {
      setGeoLocation(geoLocation);
      setSelectedProductCurrency(getGeoLocationCurrencyCode());
    };
    const getters: GetterAxios[] = [{ callback: getGeoClientData }];
    const setters: any = [setGeolocationData];

    const pageData = getAllAxiosData(getters, setters);
    pageData.catch((error) => {
      handleError(error);
    });
  }, [
    handleError,
    setSelectedProductCurrency,
    getGeoLocationCurrencyCode,
    setGeoLocation,
    searchParams,
  ]);

  useEffect(() => {
    const getters: GetterAxios[] = [{ callback: getMeInfo }];
    const setters: any = [setMe];

    const pageData = getAllAxiosData(getters, setters);
    pageData.catch((error) => {
      handleError(error);
    });
  }, [handleError, setMe]);

  return (
    <div className={`${className}`}>
      <div className="flex flex-col w-0 flex-1">
        {isOriginSetted && <PublicHeader />}
        <main className="flex-1 relative focus:outline-none z-[1]">{children}</main>
        <PublicFooter />
      </div>
    </div>
  );
};
